import { render, staticRenderFns } from "./SingleFlightItemApp.vue?vue&type=template&id=0a6db7ae&scoped=true"
import script from "./SingleFlightItemApp.vue?vue&type=script&lang=js"
export * from "./SingleFlightItemApp.vue?vue&type=script&lang=js"
import style0 from "./SingleFlightItemApp.vue?vue&type=style&index=0&id=0a6db7ae&prod&lang=css"
import style1 from "./SingleFlightItemApp.vue?vue&type=style&index=1&id=0a6db7ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6db7ae",
  null
  
)

export default component.exports